import { Icon } from '@ui/themed';
import type { ReactNode } from 'react';

export function SettingRow({
  children,
  nested = false,
}: {
  children: ReactNode;
  nested?: boolean;
}) {
  if (!nested) {
    return <div className="py-4">{children}</div>;
  }

  return (
    <div className="flex items-start gap-2 py-4">
      <span className="mt-0.5 text-gray-400">
        <Icon name="inherit" size="sm" />
      </span>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
